import PropTypes from 'prop-types';
import React from 'react';

const ReactPropTypes = PropTypes;

class Youtube extends React.Component {
	static propTypes = {
	  id: ReactPropTypes.string,
	};

	static defaultProps = {
	  id: '',
	};

	render() {
	  if (this.props.id == '') {
	    return (<span />);
	  }

	  const src = `https://www.youtube.com/embed/${this.props.id}`;

	  return (
  <div className="video-container">
    <div className="video-container-inner">
      <iframe width={560} height={315} src={src} frameBorder={0} allowFullScreen />
    </div>
  </div>
	  );
	}
}

module.exports = Youtube;
